import { Link as RouterLink } from "react-router-dom";
import type { ComponentProps, ReactNode } from "react";

export type LinkProps = Omit<ComponentProps<typeof RouterLink>, "to"> & {
  href: string;
  children?: ReactNode;
};

export default function Link({ href, children, ...rest }: LinkProps) {
  return (
    <RouterLink to={href} {...rest}>
      {children}
    </RouterLink>
  );
}
